document.documentElement.classList.remove('no-js');

const money = (pence) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(pence / 100);

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-shop-menu]');
  const toggle = document.querySelector('[data-shop-toggle]');
  const closeMenu = () => {
    if (!menu || !toggle) return;
    menu.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  };
  toggle?.addEventListener('click', (event) => {
    event.stopPropagation();
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });
  document.addEventListener('pointerdown', (event) => { if (menu && !menu.contains(event.target)) closeMenu(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelector('[data-minus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value) - 1); input.dispatchEvent(new Event('change')); });
    control.querySelector('[data-plus]')?.addEventListener('click', () => { input.value = Number(input.value) + 1; input.dispatchEvent(new Event('change')); });
    const updateProductTotal = () => {
      const form = control.closest('.product-form');
      const quantity = Math.max(1, Number(input.value) || 1);
      const summary = form?.querySelector('[data-order-summary]');
      const submit = form?.querySelector('.pdp-primary[data-unit-price]');
      const unitPrice = Number(summary?.dataset.unitPrice || submit?.dataset.unitPrice || 0);
      const total = unitPrice * quantity;
      const orderTotal = summary?.querySelector('[data-order-total]');
      const submitCopy = submit?.querySelector('[data-product-submit-copy]');
      if (orderTotal) orderTotal.textContent = money(total);
      if (submitCopy) submitCopy.textContent = `${submitCopy.textContent.split(' · ')[0]} · ${money(total)}`;
    };
    input.addEventListener('change', updateProductTotal);
    input.addEventListener('input', updateProductTotal);
    updateProductTotal();
  });

  document.querySelectorAll('[data-upload-input]').forEach((input) => {
    input.addEventListener('change', () => {
      const step = input.closest('.pdp-step');
      const selected = step?.querySelector('[data-upload-selected]');
      const preview = step?.querySelector('[data-upload-preview]');
      const prompt = step?.querySelector('[data-upload-prompt]');
      const file = input.files?.[0];
      if (selected) selected.textContent = file ? `Selected: ${file.name}` : '';
      if (!preview || !prompt) return;
      if (preview.dataset.objectUrl) URL.revokeObjectURL(preview.dataset.objectUrl);
      if (!file) {
        preview.hidden = true;
        preview.removeAttribute('src');
        prompt.hidden = false;
        return;
      }
      const objectUrl = URL.createObjectURL(file);
      preview.dataset.objectUrl = objectUrl;
      preview.src = objectUrl;
      preview.hidden = false;
      prompt.hidden = true;
      preview.onerror = () => {
        preview.hidden = true;
        prompt.hidden = false;
      };
    });
  });

  document.querySelectorAll('.usp-row, .keepsake-cards, .process-cards, .pdp-thumbs, .pdp-review-track').forEach((rail) => {
    if (rail.nextElementSibling?.classList.contains('brand-scrollbar')) return;
    const scrollbar = document.createElement('div');
    const thumb = document.createElement('span');
    scrollbar.className = `brand-scrollbar${rail.classList.contains('keepsake-cards') ? ' brand-scrollbar--dark' : ''}`;
    scrollbar.setAttribute('aria-hidden', 'true');
    scrollbar.appendChild(thumb);
    rail.insertAdjacentElement('afterend', scrollbar);
    const updateScrollbar = () => {
      const overflow = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const thumbWidth = Math.max(18, Math.min(100, (rail.clientWidth / rail.scrollWidth) * 100));
      const progress = overflow ? rail.scrollLeft / overflow : 0;
      scrollbar.hidden = overflow < 2;
      thumb.style.width = `${thumbWidth}%`;
      thumb.style.left = `${progress * (100 - thumbWidth)}%`;
    };
    rail.addEventListener('scroll', updateScrollbar, { passive: true });
    window.addEventListener('resize', updateScrollbar, { passive: true });
    window.addEventListener('load', updateScrollbar, { once: true });
    updateScrollbar();
  });

  const shell = document.querySelector('[data-cart-shell]');
  const openCart = async () => {
    if (!shell) return;
    const cart = await fetch('/cart.js').then((response) => response.json());
    const items = shell.querySelector('[data-cart-items]');
    const footer = shell.querySelector('[data-cart-footer]');
    items.innerHTML = cart.items.length ? cart.items.map((item, index) => {
      const hasUpload = Object.entries(item.properties || {}).some(([key, value]) => key === 'Original image' && value);
      return `<article><img src="${item.image || ''}" alt=""><div class="cart-item-copy"><h3>${item.product_title}</h3>${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}${hasUpload ? '<small class="cart-upload-confirmed">✓ Image attached</small>' : ''}<p><span>Qty ${item.quantity}</span><strong>${money(item.final_line_price)}</strong></p><button class="cart-remove" type="button" data-cart-remove data-cart-line="${index + 1}" aria-label="Remove item from basket"><span aria-hidden="true">×</span> Remove item</button></div></article>`;
    }).join('') : '<p class="cart-empty">Your basket is empty.</p>';
    document.querySelectorAll('.header-basket span').forEach((count) => { count.textContent = cart.item_count; count.setAttribute('aria-label', `${cart.item_count} items`); });
    footer.hidden = !cart.items.length;
    shell.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    shell.hidden = false;
    document.body.classList.add('cart-open');
  };
  const closeCart = () => { if (shell) shell.hidden = true; document.body.classList.remove('cart-open'); };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  shell?.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  shell?.querySelector('[data-cart-items]')?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-remove]');
    if (!button) return;
    const original = button.innerHTML;
    button.disabled = true;
    button.textContent = 'Removing…';
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(button.dataset.cartLine), quantity: 0 })
      });
      if (!response.ok) throw new Error('Unable to remove this item. Please try again.');
      await openCart();
    } catch (error) {
      button.disabled = false;
      button.innerHTML = original;
      button.insertAdjacentHTML('afterend', `<small class="cart-remove-error" role="alert">${error.message}</small>`);
    }
  });
  document.querySelectorAll('[data-sticky-product-submit]').forEach((button) => {
    button.addEventListener('click', () => document.querySelector('.product-form [type="submit"]')?.click());
  });
  shell?.querySelector('[data-create-another]')?.addEventListener('click', (event) => {
    const productForm = document.querySelector('.product-form');
    if (!productForm) return;
    event.preventDefault();
    closeCart();
    productForm.reset();
    productForm.querySelectorAll('[data-upload-preview]').forEach((preview) => {
      if (preview.dataset.objectUrl) URL.revokeObjectURL(preview.dataset.objectUrl);
      preview.hidden = true;
      preview.removeAttribute('src');
      delete preview.dataset.objectUrl;
    });
    productForm.querySelectorAll('[data-upload-prompt]').forEach((prompt) => { prompt.hidden = false; });
    productForm.querySelectorAll('[data-upload-selected]').forEach((selected) => { selected.textContent = ''; });
    const uploadStep = productForm.querySelector('[data-upload-input]')?.closest('.pdp-step');
    uploadStep?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.querySelectorAll('.product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const original = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add this item. Please check the details and try again.');
        await openCart();
      } catch (error) {
        const message = form.querySelector('[data-form-error]');
        if (message) message.textContent = error.message;
      } finally {
        button.disabled = false;
        button.innerHTML = original;
      }
    });
  });

  const revealSelector = [
    '.hero-copy-column', '.hero-collage', '.confidence-bar .frame > *',
    '.usp-intro > *', '.usp-row > *', '.story > *',
    '.transformation-head > *', '.transformation-grid > *',
    '.review-ribbon .frame > *', '.keepsake-head > *', '.keepsake-cards > *',
    '.product-focus > *', '.process-heading > *', '.process-cards > *',
    '.pet-keepsake > *', '.christmas-grid > *', '.quote > *',
    '.faq-grid > *', '.order-grid > *', '.pdp-gallery', '.pdp-panel',
    '.pdp-note-guide > *', '.pdp-review-track > *', '.reviews-grid > *',
    '.preorder-gallery', '.preorder-panel', '.waitlist-grid > *',
    '.collection-grid > *', '.about-hero-grid > *', '.policies-shell > *',
    '.site-footer-inner > *'
  ].join(',');

  const revealItems = [...document.querySelectorAll(revealSelector)];
  revealItems.forEach((item, index) => {
    item.classList.add('motion-reveal');
    item.style.setProperty('--motion-delay', `${Math.min(index * 35, 140)}ms`);
  });

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('motion-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0.01 });

    revealItems.forEach((item) => {
      if (item.getBoundingClientRect().top < window.innerHeight * 0.94) item.classList.add('motion-visible');
      else revealObserver.observe(item);
    });
  } else {
    revealItems.forEach((item) => item.classList.add('motion-visible'));
  }
});
